import React, { useCallback, useMemo, useState } from 'react';
import { useRefinementList, useClearRefinements } from 'react-instantsearch';
import { useDeferredValue, useTransition } from '../../../../hooks/reactShims';
import useAdvancedSearchContext from '../../../../hooks/useAdvancedSearchContext';
import MobileProductFiltersButton from './components/MobileProductFiltersButton';
import MobileProductFiltersModal from './components/MobileProductFiltersModal';
const MobileProductFilters = ({
  productsCount
}) => {
  const {
    clearSelectedColors,
    isReadyToShipActive,
    handleToggleReadyToShip,
    minWidth,
    maxWidth,
    handleWidthChange
  } = useAdvancedSearchContext();
  const {
    items: refinedFilters,
    refine: refineSearch
  } = useRefinementList({
    attribute: 'type',
    limit: 500
  });
  const {
    items: colorFilters,
    refine: refineColorFilters
  } = useRefinementList({
    attribute: 'option_color'
  });
  const deferredItems = useDeferredValue(refinedFilters);
  // Filter to only show items with results OR currently selected

  const itemsWithHits = useMemo(() => deferredItems?.filter(item => item.count > 0) || [], [deferredItems]);
  const isAnyRefined = itemsWithHits?.some(item_0 => item_0.isRefined) || false;

  // CON-7939: There is currently an Algolia context issue that results in the
  // hits count for each item not being updated correctly when any of the named
  // filters are checked - but they still reset when the search terms change.
  // We will fix this in Searchandising Phase 2.1.
  // For the Product Type filter ONLY (since it only supports one value per product),
  // instead we use the following logic here:
  // - If no filters are currently applied, show all items with hits > 0
  // - If any filters are currently applied, only show the items that are currently refined
  const items = useMemo(() => itemsWithHits.filter(item_1 => !isAnyRefined || item_1.isRefined), [itemsWithHits, isAnyRefined]);
  const {
    canRefine: canClearRefinements,
    refine: clearSearchRefinement
  } = useClearRefinements({
    includedAttributes: ['type', 'option_color']
  });
  const canClear = canClearRefinements || isReadyToShipActive || !!(minWidth || maxWidth);
  const [, startTransition] = useTransition();
  const [isMobileFiltersModalOpen, setIsMobileFiltersModalOpen] = useState(false);
  const handleOpenModal = useCallback(() => {
    setIsMobileFiltersModalOpen(true);
  }, [setIsMobileFiltersModalOpen]);
  const handleCloseModal = useCallback(() => {
    setIsMobileFiltersModalOpen(false);
  }, [setIsMobileFiltersModalOpen]);
  const refine = useCallback(value => {
    startTransition(() => {
      refineSearch(value);
    });
  }, [refineSearch]);
  const clearRefinement = useCallback(() => {
    clearSearchRefinement();
    clearSelectedColors?.();
    if (isReadyToShipActive) {
      handleToggleReadyToShip?.(false);
    }
    if (minWidth || maxWidth) {
      handleWidthChange?.('', '');
    }
  }, [clearSearchRefinement, clearSelectedColors, isReadyToShipActive, handleToggleReadyToShip, minWidth, maxWidth, handleWidthChange]);
  return <>
      <MobileProductFiltersButton onClick={handleOpenModal} items={items} />

      <MobileProductFiltersModal isOpen={isMobileFiltersModalOpen} onClose={handleCloseModal} productsCount={productsCount} items={items} refine={refine} canClear={canClear} clearRefinement={clearRefinement} colorFilters={colorFilters} refineColorFilters={refineColorFilters} />
    </>;
};
export default MobileProductFilters;